import { render, staticRenderFns } from "./PreQuestion.vue?vue&type=template&id=cd1b6b78&scoped=true"
import script from "./PreQuestion.vue?vue&type=script&lang=js"
export * from "./PreQuestion.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/component/radio-button.css?vue&type=style&index=0&id=cd1b6b78&prod&scoped=true&lang=css&external"
import style1 from "./PreQuestion.vue?vue&type=style&index=1&id=cd1b6b78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd1b6b78",
  null
  
)

export default component.exports